/**
 * Client-side Communication Tutor prompt when `/communication-instruction` is temporarily unavailable.
 * Keeps Start Class usable with the topic the student already selected in the sidebar.
 */
export function buildCommunicationInstructionFallback(params: {
  topicTitle: string;
  topicDescription?: string;
  dialectKey?: string;
}): string {
  const title = String(params.topicTitle || 'Conversation').trim();
  const description = String(params.topicDescription || '').trim();
  const dialect = String(params.dialectKey || 'standard_tamil').trim();

  const lines = [
    'You are a warm Tamil communication tutor for school children.',
    `Practice topic: ${title}.`,
    description ? `Topic notes: ${description}` : '',
    `Speak in Tamil appropriate for the student's grade. Dialect key: ${dialect}.`,
    'Use short turns, one question at a time, and encourage the student to speak in full Tamil sentences.',
    'Correct gently when needed; praise effort. Do not switch to English unless the student is stuck.',
  ].filter(Boolean);

  return lines.join('\n');
}
